import * as React from "react";
import { Tabs } from "antd";
import Box from "@mui/material/Box";

import Asset from "../Assets/Asset";
import Categories from "../Asset Category/AssetCategory";
import Location from "../Asset Location/Location";
import AssetList from "../Asset List/AssetList";
import RevalueAsset from "../Revalue Asset/RevalueAsset";
import AssetDisposal from "../Asset Disposal/AssetDisposal";
import "./style.scss";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

export default function AllAssets() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);

  const items = [
    { key: "1", label: "Add Asset", children: <Asset /> },
    { key: "2", label: "Asset Pool", children: <Categories /> },
    { key: "3", label: "Asset Locations", children: <Location /> },
    { key: "4", label: "Asset List", children: <AssetList /> },
    { key: "5", label: "Asset Revaluation", children: <RevalueAsset /> },
    { key: "6", label: "Asset Disposal", children: <AssetDisposal /> },
  ];

  return (
    <Box sx={{}}>
      <Helmet title='All Assets | Assets Register' />
      <Box
        elevation={24}
        sx={{
          bgcolor: `${mode === "dark" ? "#101418" : "#E4EADC"}`,
          width: "100%",
        }}>
        <Tabs defaultActiveKey='1' type='card' items={items} />
      </Box>
    </Box>
  );
}
